import React from "react"
import { Card, CardTitle } from "../../components/Card"
import { componentType } from "../../components/Chart"
import { HeaderContent } from "../../components/Header"
import { LoadingWithLabel } from "../../components/Loading"
import "./styles.scss"

const removeIndexStringTitle = (item) => {
  let string = item?.split("-")
  return string?.length - 1 > 1 ? string[2] : string[1]
}

const getIndexStringTitle = (item) => {
  let string = item?.split("-")
  return string?.length - 1 > 1 ? `${string[0]}-${string[1]}` : string[0]
}

const ClusteredPathTopicsScreen = ({ dataToChart, loading }) => {
  return (
    <>
      {dataToChart?.length > 0 && !loading ? (
        <div className="clustered-path-topics-container">
          {dataToChart.map((item, index) => (
            <Card className="clustered-path-topics-card no-border">
              <HeaderContent className="clustered-path-topics-card-header">
                <CardTitle title={removeIndexStringTitle(item?.question)} className="flex-start" />
                <div className="clustered-path-topics-card-header-sub flex-start">
                  <span>
                    <strong>Indíce:</strong> {getIndexStringTitle(item?.question)}
                  </span>
                </div>
              </HeaderContent>
              {componentType(item.components[0].type, {
                data: item.components[0],
                backgroundColor: index % 2 === 0 && "#DFE4E1",
                keyWord: item[0]?.title,
                value: "VALUE",
                col: item?.col || 6,
                //filterAggregationType: filter?.aggregationType?.value,
                //period: filter.period,
                //onFilter: (field, value) => handleFilter(value, field),
              })}
            </Card>
          ))}
        </div>
      ) : (
        <LoadingWithLabel labelLoading="Aguarde, estamos buscando seus dados..." />
      )}
    </>
  )
}

export default ClusteredPathTopicsScreen
